import { AGGREGATE_NAMES } from 'cpool-constants';
import type { SchemaUserResolver_GetAclPermissions } from 'cpool-tables/backend-resolvers';
import { useTranslation } from 'react-i18next';

import { ChangeAddedAdvisorModal } from './ChangeAddedAdvisorModal';
import type { AdvisorServiceLead } from './types';
import { ChangeTriggerButton } from '~/components/AssignedUsers/ChangeTriggerButton';

type Props = {
    advisorId: string;
    iconOnly?: boolean;
    lead: AdvisorServiceLead;
    permissions?: SchemaUserResolver_GetAclPermissions;
};

export const ChangeAddedAdvisorButton: React.FC<Props> = ({ advisorId, iconOnly = false, lead, permissions }) => {
    const { t } = useTranslation();

    return (
        <ChangeTriggerButton
            disabled={!permissions?.commands[AGGREGATE_NAMES.LOAN_REQUEST].changeAssignedUser}
            iconOnly={iconOnly}
            label={t('LEADS.ADVISOR_SERVICE.CHANGE_TITLE')}
            renderModal={({ onClose, open }) => (
                <ChangeAddedAdvisorModal advisorId={advisorId} lead={lead} onClose={onClose} open={open} />
            )}
            testId="change-added-advisor-button"
        />
    );
};
